import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import useFetchWellness from "./useFetchWellness";
import { BenefitDetailBlockWrapper, BenefitSummaryPostWrapper } from "./styles";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Icons, Ptag } from "components/core";
import { DetailBlock, DetailBlockMain } from "./BenefitSummary";
import { WidthLimiter } from "pages/PlanSetup/styles";

function BenefitSummaryPost() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const name = searchParams.get("name");

  const { getPlanBenefitData } = useFetchWellness();
  const [benefitDetail, setBenefitDetail] = useState();
  console.log({ benefitDetail });

  useEffect(() => {
    (async function () {
      const data = await getPlanBenefitData(params?.benefitId);
      setBenefitDetail(data);
    })();
  }, []);

  if (!benefitDetail) return null;

  console.log({ benefitDetail });
  if (benefitDetail.length == 1) {
    return (
      <BenefitSummaryPostWrapper>
        <header>
          <Ptag fontWeight="600" fontSize="20px" color="white">
            {name}
          </Ptag>
        </header>
        <section>
          {benefitDetail?.map((benefit) => (
            <>
              <BenefitDetailBlockWrapper>
                {benefitDetail?.[0]?.entity_id && (
                  <DetailBlock title="Entity ID">
                    {benefitDetail[0].entity_id}
                  </DetailBlock>
                )}
                {benefitDetail?.[0]?.vendor_name && (
                  <DetailBlock title="Vendor">
                    {benefitDetail[0].vendor_name}
                  </DetailBlock>
                )}
                {benefitDetail?.[0]?.dependents_covered && (
                  <DetailBlock title="Dependents Covered">
                    {benefitDetail[0].dependents_covered.join(", ")}
                  </DetailBlock>
                )}
                {benefitDetail?.[0]?.redeem_option_data && (
                  <DetailBlock title="Coupon">
                    {benefitDetail[0].redeem_option_data}
                  </DetailBlock>
                )}
              </BenefitDetailBlockWrapper>
              {benefitDetail?.[0]?.benefit_heading && (
                <DetailBlockMain title="Benefit Heading">
                  <Ptag color="#4A4A4A" fontSize="16px">
                    {benefitDetail?.[0]?.benefit_heading}
                  </Ptag>
                </DetailBlockMain>
              )}
              {benefitDetail?.[0]?.benefit_description && benefitDetail[0].benefit_description.trim() !== "" && (
                <DetailBlockMain title="Benefit Description">
                  <Ptag color="#4A4A4A" fontSize="16px">
                    {benefitDetail?.[0]?.benefit_description}
                  </Ptag>
                </DetailBlockMain>
              )}
              {benefitDetail?.[0]?.benefit_details?.filter((ben) => ben && ben.trim() !== "").length > 0 && (
                <DetailBlockMain title="Benefit Details">
                  <ul
                    style={{
                      listStylePosition: "inside",
                    }}
                  >
                    {benefitDetail?.[0]?.benefit_details
                      ?.filter((ben) => ben && ben.trim() !== "")
                      .map((det) => (
                        <li
                          style={{
                            fontSize: "16px",
                            fontFamily: "Inter",
                            color: "#4a4a4a",
                            fontWeight: "500",
                          }}
                        >
                          {det}
                        </li>
                      ))}
                  </ul>
                </DetailBlockMain>
              )}
            </>
          ))}
        </section>
      </BenefitSummaryPostWrapper>
    );
  }
  return (
    <BenefitSummaryPostWrapper>
      <header>
        <Ptag fontWeight="600" fontSize="20px" color="white">
          {name}
        </Ptag>
      </header>
     
      <section>
       
        {benefitDetail?.map((benefit_detail, idx) => (
          <Accordion
            defaultExpanded={idx == 0}
            sx={{
              boxShadow: "none",
              border: "1px solid #F7ECFF",
              marginBottom: "1rem",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <AccordionSummary
              sx={{
                background: "#FDEFCC",
              }}
              expandIcon={<Icons icon="chevron_down" color="white" />}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Ptag fontWeight="600" fontSize="14px" color="#231A3D">
                  Grade {idx + 1} ({benefit_detail?.grade_code})
                </Ptag>
              </div>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                background: "white",
                padding: "32px",
              }}
            >
              <BenefitDetailBlockWrapper>
                {benefit_detail?.entity_id && (
                  <DetailBlock title="Entity ID">
                    {benefit_detail.entity_id}
                  </DetailBlock>
                )}
                {benefit_detail?.dependents_covered && (
                  <DetailBlock title="Dependents Covered">
                    {benefit_detail.dependents_covered.join(", ")}
                  </DetailBlock>
                )}
                {benefit_detail?.redeem_option_data && (
                  <DetailBlock title="Coupon">
                    {benefit_detail.redeem_option_data}
                  </DetailBlock>
                )}
              </BenefitDetailBlockWrapper>
              {benefit_detail?.benefit_heading && (
                <DetailBlockMain title="Benefit Heading">
                  <Ptag color="#4A4A4A" fontSize="16px">
                    {benefit_detail?.benefit_heading}
                  </Ptag>
                </DetailBlockMain>
              )}
              {benefit_detail?.benefit_description && benefit_detail.benefit_description.trim() !== "" && (
                <DetailBlockMain title="Benefit Description">
                  <Ptag color="#4A4A4A" fontSize="16px">
                    {benefit_detail?.benefit_description}
                  </Ptag>
                </DetailBlockMain>
              )}
              {benefit_detail?.benefit_details?.filter((ben) => ben && ben.trim() !== "").length > 0 && (
                <DetailBlockMain title="Benefit Details">
                  <ul
                    style={{
                      listStylePosition: "inside",
                    }}
                  >
                    {benefit_detail?.benefit_details
                      ?.filter((ben) => ben && ben.trim() !== "")
                      .map((det) => (
                        <li
                          style={{
                            fontSize: "16px",
                            fontFamily: "Inter",
                            color: "#4a4a4a",
                            fontWeight: "500",
                          }}
                        >
                          {det}
                        </li>
                      ))}
                  </ul>
                </DetailBlockMain>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </section>
    </BenefitSummaryPostWrapper>
  );
}

export default BenefitSummaryPost;
